import axios from 'axios';
import { classifyApiError } from '@/lib/network/apiErrors';
import { getNetworkState } from '@/lib/network/connectivity';
import { isMutationMethod, retrySafeGetRequest } from '@/lib/network/safeRetry';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const DEFAULT_TIMEOUT_MS = 30000;
const AUTH_TIMEOUT_MS = 45000;

const api = axios.create({
  baseURL: API_BASE,
  timeout: DEFAULT_TIMEOUT_MS,
});

api.interceptors.request.use((config) => {
  const adminToken = sessionStorage.getItem('resqly_admin_token');
  const userToken = localStorage.getItem('resqly_token');
  const token = adminToken || userToken;

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  const url = config.url || '';
  if (url.includes('/auth/') || url.includes('/payment/')) {
    config.timeout = config.timeout || AUTH_TIMEOUT_MS;
  }

  return config;
});

api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const config = error.config || {};
    const method = (config.method || 'get').toLowerCase();

    if (
      method === 'get' &&
      !config.__skipSafeRetry &&
      !config.__safeRetryWrapped
    ) {
      try {
        config.__safeRetryWrapped = true;
        return await retrySafeGetRequest(api, config);
      } catch (retryError) {
        retryError.resqly = classifyApiError(retryError);
        return Promise.reject(retryError);
      }
    }

    error.resqly = classifyApiError(error);
    return Promise.reject(error);
  }
);

export function requiresConnection() {
  return getNetworkState().isOnline;
}

export { classifyApiError, isMutationMethod };

export default api;
